if (!customElements.get('er-quick-add')) {
  class ErQuickAdd extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('.er-quick-add__btn');
      if (this.button && !this.button.disabled) {
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          this.handleAddToCart();
        });
      }
    }

    async handleAddToCart() {
      const variantId = this.button.getAttribute('data-variant-id');
      const quantity = this.button.getAttribute('data-inventory-quantity');

      this.showLoadingState(true);
      const canAdd = await this.checkQuantity(variantId, quantity);
      if (canAdd) await this.addToCart(variantId, 1);
      this.showLoadingState(false);
    }

    async checkQuantity(variantId, quantity) {
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error('Failed to fetch cart data');

        const cartData = await response.json();
        const cartItem = cartData.items.find((item) => item.id == variantId);

        if (cartItem && cartItem.quantity >= quantity) {
          console.warn(`Cannot add more ${cartItem.title} to the cart.`);
          return false;
        }
        return true;
      } catch (error) {
        console.error('Error checking quantity:', error);
        return false;
      }
    }

    async addToCart(variantId, quantity) {
      try {
        const isPreorder = this.dataset.isPreorder === 'true';
        const bodyData = isPreorder
          ? { id: variantId, quantity, properties: { PreOrder: 'PreOrder' } }
          : { id: variantId, quantity };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(bodyData),
        });

        if (!response.ok) throw new Error('Failed to add item to cart');
        await this.onAddToCartSuccess();
      } catch (error) {
        console.error('Error adding item to cart:', error);
      }
    }

    async onAddToCartSuccess() {
      try {
        await CartUtils.openCartDrawer();
      } catch (error) {
        console.error('Error updating cart drawer and count:', error);
      }
    }

    showLoadingState(isLoading) {
      const loadingIconUrl = this.getAttribute('data-loading-icon');
      if (isLoading) {
        this.button.dataset.originalContent = this.button.dataset.originalContent || this.button.innerHTML;
        this.button.innerHTML = `<img src="${loadingIconUrl}" alt="Loading..." class="loading-spinner" />`;
        this.button.disabled = true;
      } else {
        this.button.innerHTML = this.button.dataset.originalContent;
        this.button.disabled = false;
      }
    }
  }

  customElements.define('er-quick-add', ErQuickAdd);
}
